import { useLocation } from 'react-router-dom';
import validate from 'uuid-validate';
import { Grid, Drawer } from 'antd';
import moment from 'moment';
import momentTZ from 'moment-timezone';
import AppLocale from 'lang';

class Utils {
  // 기본 금칙어
  static basicProfanity =
    "4r5e,5h1t,5hit,a55,anal,anus,ar5e,arrse,arse,ass,ass-fucker,asses,assfucker,assfukka,asshole,assholes,asswhole,a_s_s,b!tch,b00bs,b17ch,b1tch,ballbag,balls,ballsack,bastard,beastial,beastiality,bellend,bestial,bestiality,bi+ch,biatch,bitch,bitcher,bitchers,bitches,bitchin,bitching,bloody,blow job,blowjob,blowjobs,boiolas,bollock,bollok,boner,boob,boobs,booobs,boooobs,booooobs,booooooobs,breasts,buceta,bugger,bum,bunny fucker,butt,butthole,buttmunch,buttplug,c0ck,c0cksucker,carpet muncher,cawk,chink,cipa,cl1t,clit,clitoris,clits,cnut,cock,cock-sucker,cockface,cockhead,cockmunch,cockmuncher,cocks,cocksuck ,cocksucked ,cocksucker,cocksucking,cocksucks ,cocksuka,cocksukka,cok,cokmuncher,coksucka,coon,cox,crap,cum,cummer,cumming,cums,cumshot,cunilingus,cunillingus,cunnilingus,cunt,cuntlick ,cuntlicker ,cuntlicking ,cunts,cyalis,cyberfuc,cyberfuck ,cyberfucked ,cyberfucker,cyberfuckers,cyberfucking ,d1ck,damn,dick,dickhead,dildo,dildos,dink,dinks,dirsa,dlck,dog-fucker,doggin,dogging,donkeyribber,doosh,duche,dyke,ejaculate,ejaculated,ejaculates ,ejaculating ,ejaculatings,ejaculation,ejakulate,f u c k,f u c k e r,f4nny,fag,fagging,faggitt,faggot,faggs,fagot,fagots,fags,fanny,fannyflaps,fannyfucker,fanyy,fatass,fcuk,fcuker,fcuking,feck,fecker,felching,fellate,fellatio,fingerfuck ,fingerfucked ,fingerfucker ,fingerfuckers,fingerfucking ,fingerfucks ,fistfuck,fistfucked ,fistfucker ,fistfuckers ,fistfucking ,fistfuckings ,fistfucks ,flange,fook,fooker,fuck,fucka,fucked,fucker,fuckers,fuckhead,fuckheads,fuckin,fucking,fuckings,fuckingshitmotherfucker,fuckme ,fucks,fuckwhit,fuckwit,fudge packer,fudgepacker,fuk,fuker,fukker,fukkin,fuks,fukwhit,fukwit,fux,fux0r,f_u_c_k,gangbang,gangbanged ,gangbangs ,gaylord,gaysex,goatse,God,god-dam,god-damned,goddamn,goddamned,hardcoresex ,hell,heshe,hoar,hoare,hoer,homo,hore,horniest,horny,hotsex,jack-off ,jackoff,jap,jerk-off ,jism,jiz ,jizm ,jizz,kawk,knob,knobead,knobed,knobend,knobhead,knobjocky,knobjokey,kock,kondum,kondums,kum,kummer,kumming,kums,kunilingus,l3i+ch,l3itch,labia,lmfao,lust,lusting,m0f0,m0fo,m45terbate,ma5terb8,ma5terbate,masochist,master-bate,masterb8,masterbat*,masterbat3,masterbate,masterbation,masterbations,masturbate,mo-fo,mof0,mofo,mothafuck,mothafucka,mothafuckas,mothafuckaz,mothafucked ,mothafucker,mothafuckers,mothafuckin,mothafucking ,mothafuckings,mothafucks,mother fucker,motherfuck,motherfucked,motherfucker,motherfuckers,motherfuckin,motherfucking,motherfuckings,motherfuckka,motherfucks,muff,mutha,muthafecker,muthafuckker,muther,mutherfucker,n1gga,n1gger,nazi,nigg3r,nigg4h,nigga,niggah,niggas,niggaz,nigger,niggers ,nob,nob jokey,nobhead,nobjocky,nobjokey,numbnuts,nutsack,orgasim ,orgasims ,orgasm,orgasms ,p0rn,pawn,pecker,penis,penisfucker,phonesex,phuck,phuk,phuked,phuking,phukked,phukking,phuks,phuq,pigfucker,pimpis,piss,pissed,pisser,pissers,pisses ,pissflaps,pissin ,pissing,pissoff ,poop,porn,porno,pornography,pornos,prick,pricks ,pron,pube,pusse,pussi,pussies,pussy,pussys ,rectum,retard,rimjaw,rimming,s hit,s.o.b.,sadist,schlong,screwing,scroat,scrote,scrotum,semen,sex,sh!+,sh!t,sh1t,shag,shagger,shaggin,shagging,shemale,shi+,shit,shitdick,shite,shited,shitey,shitfuck,shitfull,shithead,shiting,shitings,shits,shitted,shitter,shitters ,shitting,shittings,shitty ,skank,slut,sluts,smegma,smut,snatch,son-of-a-bitch,spac,spunk,s_h_i_t,t1tt1e5,t1tties,teets,teez,testical,testicle,tit,titfuck,tits,titt,tittie5,tittiefucker,titties,tittyfuck,tittywank,titwank,tosser,turd,tw4t,twat,twathead,twatty,twunt,twunter,v14gra,v1gra,vagina,viagra,vulva,w00se,wang,wank,wanker,wanky,whoar,whore,willies,willy,xrated,xxx,개새끼,개쌔끼,개때끼,개세끼,개색끼,개색히,개쉑히,개쉑,개새꺄,개쌔꺄,개때꺄,개색꺄,개새,개쉐,십새,십쉐,씹새꺄,씹쌔꺄,씹때꺄,씹색꺄,씹새,씹쉐,병신새끼,좆나게,좃나게,존나게,젖나게,젓나게,전나게,졸라게,절라게,좆나,좃나,존나,젖나,젓나,전나,졸라,절라,좆만한,좃만한,존만한,젖만한,젓만한,좆마난,좃마난,존마난,젖마난,젓마난,좆같은,좃같은,젖같은,젓같은,좆가튼,좃가튼,,젖가튼,젓가튼,조까튼,저까튼,좆빠지게,좃빠지게,젖빠지게,젓빠지게,조빠지게,저빠지게,좆밥,좃밥,좁밥,젖밥,젓밥,접밥,조빱,저빱,좆까,좃까,젖까,젓까,조까,저까,좆도,좃도,젖도,조또,씨댕,씨뎅,씹탱,씹창,씨발,씨벌,씨불,씨이발,씨이벌,씨이불,씹팔,씹펄,씹풀,씹빡,띠발,띠벌,띠불,띠방,띠바,띠붕,띠밸,띠팔,띠펄,시벌,시팔,시이발,시이벌,시이불,시이바,시이붕,시이부,시이밸,시이팔,시이펄,시이풀,시이빡,쒸발,쒸벌,쒸불,쒸방,쒸바,쒸빡,쒸이발,쒸이벌,쒸이불,쒸이방,쒸이바,쉬발,쉬벌,쉬불,쉬방,쉬바,쉬붕,쉬부,쉬밸,쉬팔,쉬풀,쉬빡,쓰발,쓰벌,쓰불,쓰방,쓰바,쓰붕,쓰부,쓰밸,쓰팔,쓰펄,쓰풀,쓰빡,쓰이발,쓰이벌,쓰이불,까대,까댄,니미럴,니미랄,니미롤,니미룰,니미를,제기럴,제기랄,제기롤,제기룰,니기미,닝기미,니주가리,니미,쌍년,썅년,쌍넌,썅넌,쌍뇬,썅뇬,개년,개넌,개뇬,쌍놈,썅놈,쌍넘,썅넘,개놈,개넘,썅,지랄,지럴,지롤,쥐랄,쥐럴,쥐롤,병신,븅신,빙신,등신,벼엉신,빙시,미친놈,미친넘,미췬놈,미췬넘,미친년,미친뇬,미친넌,미췬년,미췬뇬,미췬넌,개자식,싸가지,싹아지,염병,옘병,니애미,니에미,c팔,개같은년,c8,개같은놈,씝할,새끠,세끠,쉐끼,새뤼,쉐끼,쇄끼,쉐끼,쇅끼,씨키,세키,ㅅㅐ끼,ㅅㅐㄲㅣ,ㅅㅐㄲㅣ,,시발,싀발,스발,스벌,쉬이발,쓰으방,쉬빨,쉬팍,스벌,씁알,씝알,씹알,씝탱,뵹신,붕신,븅싄,뵹싄,병싄,존니,죶나,죨라,죶니,죤니,죤나,죶마난,죶같은,죶가튼,죶빠지게,즤랄,질알,미친,애자,ㅇㅐ자,ㅇㅐㅈㅏ,니엠,엠창,믜친,뮈친,ㅁl친,섹히,색기,색히,병쉰,뱅신,뱅싄,뱅쉰,븽신,병쉰,애쟈,또라이,떠라이,ㅆl팔,ㅆl발,ㄴㅣㅁㅣ,ㄴlㅁl,늬미,니믜,쓰팍,씌팔,씌발,싀팔,ㅆ1팔,ㅆ1발,씹8,샹년,상년,씹년,씹뇬,챵녀,챵년,창뇬,챵뇬,잡뇬,잡년,계같은뇬,개같은뇬,개섹,죳나,니앰,앰창,애미,씹땡,씹넘,씝년,ㄱH뇬,샹놈,샹늠,개색,개자슥,게세끼,씨입년,씨입뇬,씌벌,싀방,싀봉,씌방,ㅆI발,ㅅ1발,ㅆl발,ㅆi발,ㄴ1ㅇH미,쥐랄,ㅈl랄,뷩신,뱅신,세꺄,미칀,호로자슥애,젠장,제길,젱장,우라질,제긜,젝일,바부,듕신,새키,씨벨,시벵,시펄,씹쌔,등쉬,늬귀미,조낸,씨밝,개세,개샛끼,개쉬끼,개세끼,개쓰렉기,쉬키,색갸,세캬,식키,시키,새캬,듕시나,똘아이,똘추,ㅁ1친,ㅁ1친년,뮈췬,뮈친년,미췐,미췐년,미튄,및친,벵신,병시나,병시,찐따,뷩시,새뀌,색귀,셥새,쉽년,쉽새,시바라,쉽팔,시밝,시벨,십샹,ㅆ│발,쒸뱅,씌파,씌빨,씌밸,씌바,쒸박,씨뱅,c발,g랄,zl랄,凸,미워,뉘미,뉘귀미,^^ㅣ발,ㄱㅐ,ㅅㅐㄲㅣ,ㅅㅐㄱㄱㅣ,ㅅㅐ끼,ㄱH,ㅅㅔㄲㅣ,ㅅHㄲI,ㅅH끼,ㅅㅔㄲ,ㅅ1팔,ㅆㅣ불,ㅆㅂ,ㅅㅂ,씹발,개`,개쇄,씨`발,새'꺄,새'끼,색끼,섀캬,샹뇬,쇄키,싯팔,개씹,섀끼,쌔기,ㅁㅣ친,ㅁl친,망할,씨박,씨'발,씨벵,씨빨,씨파,씨브랄,씨팍,씹빨,씹세,씹쌍,ㅈ1랄,ㅆㅣ발,ㅆㅣ방,ㅆㅣ팔,ㅆㅣ벌,ㅆ!발,ㅆㅣ발,쒸벨,등쉰,똘츄,ㄴㅣ미,ㄴㅣㄱㅣ,ㄴ1ㄱ1,ㄴ1ㅁ1,ㄴ1미,ㄴ1ㅇㅐ,ㄴ1애,니M창,니OH미,뷩신,뷩쉰,븅쉰,빙쉰,시팍,시빨,시파,시밸,쉽뇬,개련,ㅆ1밸,ㅆ1벨,호구,씌벨,애좌,씻팔,ㅆ1바,개샛히애,색휘,싯끼,섹키,쓉년,쓉창,호로자식애,씌뱅,씨팰,씌댕,씌뎅,씹쒜,엠병,앰병,후레자식애,후레자슥애,호로년,후레년,씹빠,뻑큐,빠큐,ㅃr큐,개섀끼,개샹련,니뮈럴,늬기미,앰창,엠창,쓰박,씨부랄,씹샹,연병,시밟,뒤져,짜져,꺼져,잡놈,뒤질래,디질래,아갈,닥쳐,허접,흐접,찌질이,낙태아,다방년,호모,엿먹어,개자지,개보지,애비자지,애미보지,자지,잠지,보지,섹스,공알,좆,좇,좃,젖,빨통,딸딸이,딸따리,빠구리,빠굴이,빠굴,빠순이,빠수니,사까시,불알,부랄,번섹,번쌕,번쎅,떡치기,후장,섹스,색스,쎅스,쌕스,쉑스,섹쓰,색쓰,쎅쓰,쌕쓰,쉑쓰,창녀,창년,갈보,개싑창,죷,죳,좆나,좇나,존나,죤나,욧나,쟈지,죠또,죵나,자쥣,죠빠,쫓까,죡쳐,보쥐,쟘쥐,꼬추,꼬츄,강간,걸레년,곧휴,쟘지,ㅈㅏㅈㅣ,ㅈㅏ지,자쥐,잠쥐,쟘쥐,보'지,섹'스,유두,유방,차앙년,창ㄴㅕ,창뇬,촹년,촹뇬,폰섹,ㅃㅏ구리,ㅃr굴,고츄,붕알,폰색,죠까,porno,dildo,pussy,shit,bitch,anal,fetish,gay,lesbien,cunt,damn,귀두,뽕알";

  // - 포함된 전화번호
  static regExPhoneNumber = /^[0-9]{2,3}-[0-9]{3,4}-[0-9]{4}$/;

  // - 제외된 전화번호
  static regExPhoneNumber2 = /^[0-9]{2,3}[0-9]{3,4}[0-9]{4}$/;

  static regExID = /^[A-Za-z0-9]{4,32}$/;

  static regExEmail = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/;

  // 하나 이상의 영문 대문자 (?=.*?[AZ])
  // 적어도 하나의 영문 소문자 (?=.*?[az])
  // 하나 이상의 숫자 (?=.*?[0-9])
  // 하나 이상의 특수 문자 (?=.*?[#?!@$%^&*-])
  // 허용된 문자 [a-zA-Z0-9#?!@$%^&*-]
  // 최소 길이 8 인치 .{8,} (앵커 포함)
  static regPW = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).[a-zA-Z0-9#?!@$%^&*-]{7,}$/;

  /**
   * Get first character from first & last sentences of a username
   * @param {String} name - Username
   * @return {String} 2 characters string
   */
  static getNameInitial(name) {
    let initials = name.match(/\b\w/g) || [];
    return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
  }

  /**
   * Get current path related object from Navigation Tree
   * @param {Array} navTree - Navigation Tree from directory 'configs/NavigationConfig'
   * @param {String} path - Location path you looking for e.g '/app/dashboards/analytic'
   * @return {Object} object that contained the path string
   */
  static getRouteInfo(navTree, path) {
    let result = undefined;
    if (path.startsWith(navTree.path)) {
      result = navTree;
    }
    let route;
    for (let p in navTree) {
      if (navTree.hasOwnProperty(p) && typeof navTree[p] === 'object') {
        route = this.getRouteInfo(navTree[p], path);
        if (route) {
          result = route;
        }
      }
    }
    return result;
  }
  /**
   * Get accessible color contrast
   * @param {String} hex - Hex color code e.g '#3e82f7'
   * @return {String} 'dark' or 'light'
   */
  static getColorContrast(hex) {
    const threshold = 130;
    const hRed = hexToR(hex);
    const hGreen = hexToG(hex);
    const hBlue = hexToB(hex);
    function hexToR(h) {
      return parseInt(cutHex(h).substring(0, 2), 16);
    }
    function hexToG(h) {
      return parseInt(cutHex(h).substring(2, 4), 16);
    }
    function hexToB(h) {
      return parseInt(cutHex(h).substring(4, 6), 16);
    }
    function cutHex(h) {
      return h.charAt(0) === '#' ? h.substring(1, 7) : h;
    }
    const cBrightness = (hRed * 299 + hGreen * 587 + hBlue * 114) / 1000;
    if (cBrightness > threshold) {
      return 'dark';
    } else {
      return 'light';
    }
  }

  /**
   * Darken or lighten a hex color
   * @param {String} color - Hex color code e.g '#3e82f7'
   * @param {Number} percent - Percentage -100 to 100, positive for lighten, negative for darken
   * @return {String} Darken or lighten color
   */
  static shadeColor(color, percent) {
    let R = parseInt(color.substring(1, 3), 16);
    let G = parseInt(color.substring(3, 5), 16);
    let B = parseInt(color.substring(5, 7), 16);
    R = parseInt((R * (100 + percent)) / 100);
    G = parseInt((G * (100 + percent)) / 100);
    B = parseInt((B * (100 + percent)) / 100);
    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;
    const RR =
      R.toString(16).length === 1 ? `0${R.toString(16)}` : R.toString(16);
    const GG =
      G.toString(16).length === 1 ? `0${G.toString(16)}` : G.toString(16);
    const BB =
      B.toString(16).length === 1 ? `0${B.toString(16)}` : B.toString(16);
    return `#${RR}${GG}${BB}`;
  }

  /**
   * Returns either a positive or negative
   * @param {Number} number - number value
   * @param {any} positive - value that return when positive
   * @param {any} negative - value that return when negative
   * @return {any} positive or negative value based on param
   */
  static getSignNum(number, positive, negative) {
    if (number > 0) {
      return positive;
    }
    if (number < 0) {
      return negative;
    }
    return null;
  }

  /**
   * Returns either ascending or descending value
   * @param {Object} a - antd Table sorter param a
   * @param {Object} b - antd Table sorter param b
   * @param {String} key - object key for compare
   * @return {any} a value minus b value
   */
  static antdTableSorter(a, b, key) {
    if (typeof a[key] === 'number' && typeof b[key] === 'number') {
      return a[key] - b[key];
    }

    if (typeof a[key] === 'string' && typeof b[key] === 'string') {
      a = a[key].toLowerCase();
      b = b[key].toLowerCase();
      return a > b ? -1 : b > a ? 1 : 0;
    }
    return;
  }

  /**
   * Filter array of object
   * @param {Array} list - array of objects that need to filter
   * @param {String} key - object key target
   * @param {any} value  - value that excluded from filter
   * @return {Array} a value minus b value
   */
  static filterArray(list, key, value) {
    let data = list;
    if (list) {
      data = list.filter((item) => item[key] === value);
    }
    return data;
  }

  /**
   * Remove object from array by value
   * @param {Array} list - array of objects
   * @param {String} key - object key target
   * @param {any} value  - target value
   * @return {Array} Array that removed target object
   */
  static deleteArrayRow(list, key, value) {
    let data = list;
    if (list) {
      data = list.filter((item) => item[key] !== value);
    }
    return data;
  }

  /**
   * Wild card search on all property of the object
   * @param {Number | String} input - any value to search
   * @param {Array} list - array for search
   * @return {Array} array of object contained keyword
   */
  static wildCardSearch(list, input) {
    const searchText = (item) => {
      for (let key in item) {
        if (item[key] == null) {
          continue;
        }
        if (
          item[key]
            .toString()
            .toUpperCase()
            .indexOf(input.toString().toUpperCase()) !== -1
        ) {
          return true;
        }
      }
    };
    list = list.filter((value) => searchText(value));
    return list;
  }

  /**
   * Get Breakpoint
   * @param {Object} screens - Grid.useBreakpoint() from antd
   * @return {Array} array of breakpoint size
   */
  static getBreakPoint(screens) {
    let breakpoints = [];
    for (const key in screens) {
      if (screens.hasOwnProperty(key)) {
        const element = screens[key];
        if (element) {
          breakpoints.push(key);
        }
      }
    }
    return breakpoints;
  }

  static isTablet() {
    return !this.getBreakPoint(Grid.useBreakpoint()).includes('lg');
  }

  static isMobile() {
    return !this.getBreakPoint(Grid.useBreakpoint()).includes('md');
  }

  static getID(id) {
    if (!id || id === '') return '';

    let result = '';

    const decodedid = new Buffer(id, 'base64').toString('utf-8');

    let splitArr = decodedid.split(':');

    if (splitArr.length > 2) {
      splitArr.forEach((item, index) => {
        if (index != 0) {
          if (index === 1) {
            result += item;
          } else {
            result += ':' + item;
          }
        }
      });
    } else {
      result = splitArr[1];
    }

    return result;
  }

  static isEmpty(data) {
    let empty = false;

    // default
    if (data === undefined || data === null) {
      empty = true;
      return empty;
    }

    // type check
    if (typeof data === 'string' && (data === '' || data.trim() === '')) {
      empty = true;
    } else if (Array.isArray(data)) {
      empty = data.length <= 0;
    }

    return empty;
  }

  static getProjectID() {
    const location = useLocation();
    const projectId = location.pathname.split('/')[1];
    if (validate(projectId, 4) === false) return false;
    return projectId;
  }

  static getBrowserLocale() {
    var lang;

    if (navigator.languages && navigator.languages.length) {
      // latest versions of Chrome and Firefox set this correctly
      lang = navigator.languages[0];
    } else if (navigator.userLanguage) {
      // IE only
      lang = navigator.userLanguage;
    } else {
      // latest versions of Chrome, Firefox, and Safari set this correctly
      lang = navigator.language;
    }

    return lang;
  }

  static getCurrentLocale() {
    var result = '';

    var localStorageLocale = localStorage.getItem('locale');

    if (this.isEmpty(localStorageLocale)) {
      result = this.getBrowserLocale();
    } else {
      result = localStorageLocale;
    }

    let splitData = result.split('-');

    if (AppLocale[splitData[0]] == null) {
      result = 'ko-KR';
    } else {
      result = AppLocale[splitData[0]].locale;
    }

    return result;
  }

  static getCurrentLanguage() {
    var result = '';

    var locale = this.getCurrentLocale();

    if (this.isEmpty(locale)) {
      result = 'ko';
    } else {
      result = locale.split('-')[0];
    }

    return result;
  }

  static getAppLocaleData(locale) {
    if (Utils.isEmpty(locale)) {
      return AppLocale['ko'];
    }

    let result = locale.split('-');

    if (AppLocale[result[0]] == null) {
      return AppLocale['ko'];
    }

    return AppLocale[result[0]];
  }

  static exportCheckPriod(startDate, endDate, date) {
    if (this.isEmpty(startDate)) {
      return false;
    }

    if (this.isEmpty(endDate)) {
      return false;
    }

    const tStartDate = moment(startDate).format('YYYY-MM-DD');
    const tEndDate = moment(endDate).format('YYYY-MM-DD');

    if (tStartDate && tEndDate) {
      const diffDay = moment(tEndDate).diff(moment(tStartDate), 'days');

      if (diffDay + 1 > date) {
        return false;
      }

      return true;
    }

    return false;
  }

  static getTimezoneList() {
    const result = [];

    momentTZ.tz.names().map((item) => {
      result.push({
        desc: `(GMT ${moment.tz(item).format('Z')}) ${item}`,
        country: item,
        offset: moment.tz(item).format('Z'),
      });
    });

    // offsetTmz = offsetTmz.sort((a, b) => a.offset.toString().localeCompare(b.offset.toString()));

    return result;
  }

  static setDefaultTimezone(timezone) {
    moment.tz.setDefault(timezone);
  }

  static excloud(obj, key) {
    const newObj = {};

    if (obj !== null && obj !== undefined) {
      const keys = Object.keys(obj);

      keys.forEach((tempkey) => {
        const val = obj[tempkey];

        if (typeof val === 'object' && val !== null)
          newObj[tempkey] = Utils.excloud(val, key);
        else if (typeof val === 'boolean' && val !== null)
          newObj[tempkey] = val;
        else if (val !== null && val.includes('****') === false) {
          newObj[tempkey] = val;
        }
      });
    }

    return newObj;
  }

  static omitDeep(obj, key) {
    if (Array.isArray(obj)) return Utils.omitDeepArrayWalk(obj, key);

    if (obj !== null && obj !== undefined) {
      const keys = Object.keys(obj);
      const newObj = {};
      keys.forEach((i) => {
        if (i !== key) {
          const val = obj[i];
          if (Array.isArray(val)) newObj[i] = Utils.omitDeepArrayWalk(val, key);
          else if (typeof val === 'object' && val !== null)
            newObj[i] = Utils.omitDeep(val, key);
          else newObj[i] = val;
        }
      });
      return newObj;
    }
  }

  static omitDeepArrayWalk(arr, key) {
    return arr.map((val) => {
      if (Array.isArray(val)) return Utils.omitDeepArrayWalk(val, key);
      if (typeof val === 'object') return Utils.omitDeep(val, key);
      return val;
    });
  }

  static getMessage(message) {
    // console.log(message);
    if (this.isEmpty(message)) {
      return '';
    }

    if (typeof message === 'object') {
      // console.log('obj');
      return JSON.stringify(message);
    } else {
      // console.log('string');
      return message;
    }
  }

  static checkInternetExpoler(navigator) {
    const agent = navigator.userAgent.toLowerCase();
    const { appName } = navigator;

    if (
      (appName === 'Netscape' &&
        navigator.userAgent.search('Trident') !== -1) ||
      agent.indexOf('msie') !== -1
    ) {
      return true;
    }
    return false;
  }
}

export default Utils;
